import QualificationListHeader from "./components/QualificationListHeader";
import QualificationListTable from "./components/QualificationListTable";
import { JSX } from "react";

const QualificationListPageContainer = (): JSX.Element => {
    return (
        <section className="p-qualification-list">
            <QualificationListHeader />
            <QualificationListTable />
        </section>
    );
};

export default QualificationListPageContainer;
